import { ChakraProvider } from '@chakra-ui/react'
import { theme } from '@chakra-ui/pro-theme'
import { extendTheme } from '@chakra-ui/react'
import { withProse } from '@nikolovlazar/chakra-ui-prose'

const proTheme = extendTheme(theme)
const extenstion = {
  colors: {
    ...proTheme.colors,
    brand: {
      50: "#E6F2FF",
      100: "#B9D9FE",
      200: "#8CC1FD",
      300: "#5FA9FC",
      400: "#3291FB",
      500: "#034EA2",
      600: "#0460C8",
      700: "#034896",
      800: "#023064",
      900: "#011832"
    },
    secondary: {
      50: "#d2df83",
      300: "#96c247",
      500: "#6bb745",
      800: "#003612",
      900: "#00662f",
    }
  },
  fonts: {
    heading: "'titillium web', -apple-system, system-ui, sans-serif",
    body: "'titillium web', -apple-system, system-ui, sans-serif",
  },
  components: {
    Drawer: {
      variants: {
        alwaysOpen: {
          parts: ['dialog, dialogContainer'],
          dialog: {
            pointerEvents: 'auto',
          },
          dialogContainer: {
            pointerEvents: 'none',
          },
        },
      },
    },
    Button: {
      baseStyle: {
        borderTopLeftRadius:8,
        borderTopRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 8
      },
      defaultProps: {
                  
      }
    },
    Input: {
      baseStyle: {
        field: {
          _placeholder: {
            opacity: 0.75
          }
        }
      }
    },
    Table: {
      baseStyle: {
        th: {
          paddingLeft: '1rem!important',
          paddingRight: '1rem!important',
        },
        td: {
          paddingLeft: '1rem!important',
          paddingRight: '1rem!important',
        },
      }
    },
    Link: {
      variants: {
        // you can name it whatever you want
        primary: ({ colorScheme = "blue" }) => ({
          color: `${colorScheme}.500`,
          _hover: {
            color: `${colorScheme}.400`,
          },
        }),
      },
      defaultProps: {
        // you can name it whatever you want
        variant: "primary",
      },
    },
  }
}
const myTheme = extendTheme(extenstion, withProse(), proTheme)

export function ChakraUiProvider({ children }: { children: React.ReactNode }) {
  return <ChakraProvider theme={myTheme} toastOptions={{ defaultOptions: { position: 'top' } }}>{children}</ChakraProvider>
}